var exports = {
  "Qs": "AddConnectionModal.module__content___NGtvR2",
  "t$": "AddConnectionModal.module__stack___NGtvR2",
  "GA": "AddConnectionModal.module__instructions___NGtvR2",
  "G5": "AddConnectionModal.module__dnsCard___NGtvR2",
  "KJ": "AddConnectionModal.module__dnsHeading___NGtvR2",
  "Eq": "AddConnectionModal.module__dnsTitle___NGtvR2",
  "h_": "AddConnectionModal.module__dnsFields___NGtvR2",
  "ti": "AddConnectionModal.module__inlineCode___NGtvR2",
  "_c": "AddConnectionModal.module__dnsInput___NGtvR2",
  "x": "AddConnectionModal.module__orDivider___NGtvR2",
  "LC": "AddConnectionModal.module__orDividerLine___NGtvR2",
  "AS": "AddConnectionModal.module__orDividerText___NGtvR2",
  "iW": "AddConnectionModal.module__tokenCard___NGtvR2",
  "TN": "AddConnectionModal.module__tokenCardHeader___NGtvR2",
  "q6": "AddConnectionModal.module__tokenTitle___NGtvR2",
  "wc": "AddConnectionModal.module__tokenSubtitle___NGtvR2",
  "OB": "AddConnectionModal.module__tokenDownloadRow___NGtvR2",
  "RB": "AddConnectionModal.module__tokenMeta___NGtvR2",
  "cL": "AddConnectionModal.module__copyButton___NGtvR2",
  "nJ": "AddConnectionModal.module__copyIcon___NGtvR2",
};

module.exports = exports;
